import { AppThunkAction } from '../reducers';

// services
import { FileUploadServices } from '../../services/FileUpload.Services';

// actions
import * as Actions from '../actions';

// models
import { FileUpload, FileUploadRequest } from '../../models/Entities/Contracts/FileUpload';
import { FileUploadFilters } from '../../models/Filters/FileUploadFilters';
import { ErrorType } from '../../models/HttpError';

type KnownAction = 
    | Actions.FileUpload.FileUploadGetAllRequestAction
    | Actions.FileUpload.FileUploadGetAllSuccessAction
    | Actions.FileUpload.FileUploadGetAllFailureAction
    | Actions.FileUpload.FileUploadGetByIdRequestAction
    | Actions.FileUpload.FileUploadGetByIdSuccessAction
    | Actions.FileUpload.FileUploadGetByIdFailureAction
    | Actions.FileUpload.FileUploadCreateRequestAction
    | Actions.FileUpload.FileUploadCreateSuccessAction
    | Actions.FileUpload.FileUploadCreateFailureAction
    | Actions.FileUpload.FileUploadDeleteRequestAction
    | Actions.FileUpload.FileUploadDeleteSuccessAction
    | Actions.FileUpload.FileUploadDeleteFailureAction;

export const actionCreators = {
    GetAllFileUploads: (filters?: FileUploadFilters): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        let token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                } as ErrorType
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        if(filters?.entityId === undefined || filters?.entityId === null || filters?.entityId === 0) {
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 400,
                    ErrorMessage: 'Entity ID is required',
                    Errors: []
                } as ErrorType
            });
            return;
        }

        dispatch({ type: Actions.FileUpload.FILE_UPLOAD_GET_ALL_REQUEST, ContractId: filters?.entityId ?? 0 });        try {
            const safeFilters: FileUploadFilters = filters ?? {};
            console.log('FileUploadMiddleware - Calling getFiles with filters:', safeFilters);
            const response = await FileUploadServices.getFiles(safeFilters, token);
            console.log('FileUploadMiddleware - Response from getFiles:', response);
            console.log('FileUploadMiddleware - Data items:', response.data?.items);
            
            const files = Array.isArray(response.data?.items) ? response.data.items : [];
            console.log('FileUploadMiddleware - Dispatching files:', files);
            
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_ALL_SUCCESS,
                Files: files
            });
        } catch (error) {
            let errorMessage = 'Failed to fetch files';
            if (error && typeof error === 'object' && 'message' in error) {
                errorMessage = (error as Error).message;
            }
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_ALL_FAILURE,
                error: {
                    ErrorCode: 500,
                    ErrorMessage: errorMessage,
                    Errors: []
                } as ErrorType
            });
        }
    },

    GetFileUploadById: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        let token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                } as ErrorType
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        dispatch({ type: Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_REQUEST, FileId: id });

        try {
            const response = await FileUploadServices.getFiles({ entityId: id }, token);
            // Assuming the first file from the response is the requested file
            const file = response.data && Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : null;
            if (file) {
                dispatch({
                    type: Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_SUCCESS,
                    File: file
                });
            } else {
                dispatch({
                    type: Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_FAILURE,
                    error: {
                        ErrorCode: 404,
                        ErrorMessage: 'File not found',
                        Errors: []
                    } as ErrorType
                });
            }
        } catch (error) {
            let errorMessage = 'Failed to fetch file';
            if (error && typeof error === 'object' && 'message' in error) {
                errorMessage = (error as Error).message;
            }
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_GET_BY_ID_FAILURE,
                error: {
                    ErrorCode: 500,
                    ErrorMessage: errorMessage,
                    Errors: []
                } as ErrorType
            });
        }
    },

    CreateFileUpload: (fileUpload: FileUpload, onUploadProgress?: (percent: number) => void): AppThunkAction<KnownAction> => async (dispatch, getState) => {

        const state = getState();
        let token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_CREATE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                } as ErrorType
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }        dispatch({ type: Actions.FileUpload.FILE_UPLOAD_CREATE_REQUEST, File: fileUpload });
        
        try {            // Create a proper FileUploadRequest from the FileUpload object
            const uploadRequest: FileUploadRequest = {
                file: fileUpload.File, // Assuming FileUpload has a File property
                entityType: fileUpload.entityType,
                entityId: fileUpload.entityId,
                tags: fileUpload.tags,
                metadata: fileUpload.metadata,
                onUploadProgress
            };
            
            const response = await FileUploadServices.uploadFile(uploadRequest, token);
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_CREATE_SUCCESS,
                File: response.data || fileUpload
            });
        } catch (error) {
            let errorCode = 500;
            let errorMessage = 'Failed to create file';

            if (error && typeof error === 'object' && 'message' in error) {
                const rawMessage = (error as Error).message;
                try {
                    const parsed = JSON.parse(rawMessage);
                    errorCode = parsed?.ErrorCode ?? errorCode;
                    errorMessage = parsed?.ErrorMessage ?? errorMessage;
                } catch {
                    errorMessage = rawMessage;
                }
            }

            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_CREATE_FAILURE,
                error: {
                    ErrorCode: errorCode,
                    ErrorMessage: errorMessage,
                    Errors: []
                } as ErrorType
            });
            throw error;
        }
    },

    DeleteFileUpload: (id: number): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        let token: string;

        if (state.oidc?.user?.access_token === undefined) {
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_DELETE_FAILURE,
                error: {
                    ErrorCode: 401,
                    ErrorMessage: 'Not authorized',
                    Errors: []
                } as ErrorType
            });
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        dispatch({ type: Actions.FileUpload.FILE_UPLOAD_DELETE_REQUEST, FileId: id });

        try {
            await FileUploadServices.deleteFile(id, token);
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_DELETE_SUCCESS,
                FileId: id
            });
        } catch (error) {
            let errorMessage = 'Failed to delete file';
            if (error && typeof error === 'object' && 'message' in error) {
                errorMessage = (error as Error).message;
            }
            dispatch({
                type: Actions.FileUpload.FILE_UPLOAD_DELETE_FAILURE,
                error: {
                    ErrorCode: 500,
                    ErrorMessage: errorMessage,
                    Errors: []
                } as ErrorType
            });
        }
    },
    DownloadFile: (fileId: number, fileName?: string): AppThunkAction<KnownAction> => async (dispatch, getState) => {
        const state = getState();
        let token: string;
        if (state.oidc?.user?.access_token === undefined) {
            return;
        } else {
            token = state.oidc.user.access_token;
        }

        try {
            const file: {file:Blob, fileName: string} = await FileUploadServices.downloadFile(fileId, token);

            // send to explorer to download
            const url = window.URL.createObjectURL(file.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = file.fileName ? file.fileName : `file_${fileId}.pdf`; // Set the file name
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        } catch (error) {
            let errorMessage = 'Failed to download file';
            if (error && typeof error === 'object' && 'message' in error) {
                errorMessage = (error as Error).message;
            }
        }
    }
};
